module.exports = __webpack_public_path__ + "media/images/lp/1/support1-sp-ff27b0181860b6a0c8ea54059dbf5980.png";